import { Link } from 'react-router-dom';
import { categoryMap } from '@/mocks/content';

export default function CategoryQuickLinks() {
  const links = [
    { ...categoryMap.movie, icon: 'ri-film-line', desc: '院线大片 · 高分佳作' },
    { ...categoryMap.tv, icon: 'ri-tv-2-line', desc: '热播剧集 · 每日更新' },
    { ...categoryMap.variety, icon: 'ri-live-line', desc: '热门综艺 · 欢乐不断' },
  ];

  return (
    <section className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-8">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {links.map((link) => (
          <Link
            key={link.slug}
            to={`/category/${link.slug}`}
            className="group flex items-center gap-4 p-5 rounded-lg bg-background-100 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
              <i className={`${link.icon} text-xl`} />
            </div>
            <div>
              <h3 className="text-sm font-semibold text-foreground-900">{link.label}</h3>
              <p className="text-xs text-foreground-500 mt-0.5">{link.desc}</p>
            </div>
            <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 ml-auto transition-colors duration-200" />
          </Link>
        ))}
      </div>
    </section>
  );
}